import { render, staticRenderFns } from "./seguro-empate-toggle.vue?vue&type=template&id=620ebbb3&scoped=true&"
import script from "./seguro-empate-toggle.vue?vue&type=script&lang=js&"
export * from "./seguro-empate-toggle.vue?vue&type=script&lang=js&"
import style0 from "./seguro-empate-toggle.vue?vue&type=style&index=0&id=620ebbb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ebbb3",
  null
  
)

export default component.exports